export default {
    link: 'career-birth-chart',
    name: 'Mapa Astral de Carreira',
    title: 'Mapa Astral de Carreira',

    customContent: {
        houses: {
            house: 'Casa {house}',
            noPositions: 'Não há astros posicionados nessa casa.',
            others: 'Outras casas astrológicas',

            titles: {
                money: 'Dinheiro e recursos',
                creativity: 'Criatividade e expressão',
                routine: 'Rotina e ambiente de trabalho',
                partnerships: 'Parcerias e sociedades',
                career: 'Carreira e reputação'
            }
        },

        aspects: {
            fluid: 'Suas vantagens e estabilidades',
            tense: 'Suas interferências e pontos de atenção',
            title: '{planet1} {aspect} {planet2}',

            names: {
                conjunction: 'conjunção',
                opposition: 'oposição',
                trine: 'trígono',
                square: 'quadratura',
                sextile: 'sextil'
            }
        }
    },

    paywall: {
        title: 'Descubra o que está entre você e o sucesso que já podia ser seu',

        benefits: {
            title: 'O QUE VOCÊ VAI DESCOBRIR:',
            talents: '<strong>Vocação e talentos</strong>',
            cooperation: '<strong>Liderança, autonomia e cooperação</strong>',
            money: '<strong>Empreendedorismo e potencial financeiro</strong>',
            aspects: '<strong>Casas e aspectos da sua carreira</strong>',
            market: '<strong>Panorama do mercado de trabalho de hoje</strong>',
            workValues: '<strong>Os quatro valores do trabalho e dicas práticas</strong>'
        }
    },

    paywallOTS: {
        hero: {
            alt: 'Ilustração do Mapa Astral de Carreira com símbolos astrológicos ligados a trabalho, propósito e dinheiro'
        },

        limitedOffer: 'Um mapa para levar você à sua realização profissional e financeira',
        mainTitle: 'Descubra o que está entre você e o próximo passo para o seu sucesso!',
        mainSubtitle:
            'Sua análise de carreira personalizada já está pronta. Conheça seus talentos, sua forma de liderar e o caminho que te leva mais rápido para a estabilidade e a prosperidade que você busca.',

        benefits: {
            title: 'O QUE VOCÊ VAI DESCOBRIR:',
            items: {
                0: {
                    title: 'Vocação e talentos',
                    text: 'Entenda quais <b>habilidades naturais</b> você tem e onde elas <b>se encaixam melhor no mercado</b>'
                },
                1: {
                    title: 'Liderança, autonomia e cooperação',
                    text: 'Descubra seu estilo de atuação e como lidar melhor com <b>desafios no trabalho</b>'
                },
                2: {
                    title: 'Empreendedorismo e potencial financeiro',
                    text: 'Veja exatamente como transformar o que você já tem de talento em <b>dinheiro</b>, <b>estabilidade</b> e <b>reconhecimento</b>'
                },
                3: {
                    title: 'Casas e aspectos da sua carreira',
                    text: 'Leitura completa dos pontos do seu mapa astral ligados a <b>profissão</b>, <b>trabalho</b> e <b>finanças</b>'
                },
                4: {
                    title: 'Panorama do mercado de trabalho de hoje',
                    text: 'Contexto histórico e atual sobre as <b>transformações da carreira</b>, avanços tecnológicos e como se posicionar'
                },
                5: {
                    title: 'Os quatro valores do trabalho e dicas práticas',
                    text: 'Descubra o que você mais busca: <b>retorno financeiro</b>, <b>motivação</b>, <b>ambiente</b> ou <b>reconhecimento</b>'
                }
            }
        },

        payment: {
            callout: {
                subscriber: 'OFERTA ESPECIAL PARA ASSINANTES',
                nonSubscriber: 'OFERTA ESPECIAL'
            },
            from: '<del>De {fullPrice}</del> Acesso completo por apenas',
            price: '<span></span><span>{value}</span>',
            installments: '<span>{installments}x</span><span>{installmentValue}</span>',
            cash: 'sem juros ou à vista: <b>{cashPrice}</b>',
            details:
                '<b>🎁 Compra única · Acesso vitalício</b><br/>⭐ Acesso imediato pelo Astrolink<br/>🔒 Compra segura',
            bonus: 'Assinantes Premium: <strong>{subscriberPrice}</strong>'
        },

        paymentButtons: {
            installments: 'Parcelamento em até {installments}x sem juros',
            creditCard: 'Comprar com Cartão',
            pixWeb: 'Comprar com Pix em 1 clique',
            pixApp: 'Comprar com Pix'
        },

        whyUs: {
            title: 'Por que o Mapa de Carreira do Astrolink é o melhor para você?',
            items: {
                0: {
                    bold: 'Foco em decisão real:',
                    text: 'não é só teoria, é aplicação prática para o seu momento de carreira'
                },
                1: {
                    bold: 'Personalizado para você:',
                    text: 'nada de conselhos genéricos, é o seu mapa, os seus talentos'
                },
                2: {
                    bold: 'Profundidade astrológica de verdade:',
                    text: 'conteúdo didático, sem sensacionalismo, feito por quem entende do assunto'
                },
                3: {
                    bold: 'Conteúdo completo:',
                    text: 'análise aprofundada que você pode reler sempre que precisar se reposicionar'
                }
            }
        },

        testimonials: {
            title: 'Você faz parte de uma comunidade com mais de <strong>22 milhões</strong> de mapas astrais criados',
            subtitle: 'Agora é a vez de olhar para a sua carreira com a mesma profundidade.',
            items: {
                0: {
                    text: 'Eu sabia que tinha talento pra alguma coisa, só não sabia pra quê. O Mapa de Carreira me mostrou onde eu realmente tinha potencial e hoje eu ganho mais fazendo algo que faz sentido pra mim.',
                    name: 'Renata',
                    sign: 'Sagitariana'
                },
                1: {
                    text: 'Troquei de área depois de ler o meu mapa. Foi a primeira vez que alguém me explicou por que eu nunca me sentia realizada, mesmo ganhando bem. Hoje penso diferente sobre sucesso.',
                    name: 'Vanessa',
                    sign: 'Capricorniana'
                }
            }
        },

        comparison: {
            title: 'Veja a diferença que conhecer o seu mapa de carreira faz:',
            without: {
                title: 'DÚVIDAS CONSTANTES',
                items: {
                    0: 'Insegurança sobre qual caminho seguir',
                    1: 'Sensação de estar perdido(a) na carreira',
                    2: 'Dificuldade de reconhecer os próprios talentos',
                    3: 'Medo de tomar a decisão errada',
                    4: 'Sente que trabalha muito e não vê retorno',
                    5: 'Repete os mesmos padrões que travam o crescimento'
                }
            },
            with: {
                title: 'COM O MAPA DE CARREIRA',
                items: {
                    0: '<strong>Clareza total</strong> sobre seus talentos e vocação',
                    1: 'Toma decisões com mais <strong>confiança</strong>',
                    2: 'Reconhece seu <strong>estilo de liderar</strong> e cooperar',
                    3: 'Sabe transformar <strong>talento em resultado financeiro</strong>',
                    4: 'Identifica os padrões que travam o seu crescimento',
                    5: '<strong>Sente que está no caminho certo</strong>, com propósito'
                }
            }
        },

        finalCta: {
            text: 'Adquira seu Mapa de Carreira personalizado em <strong>uma compra única</strong> e leia sempre que precisar',
            button: 'Quero meu Mapa de Carreira'
        },

        terms: {
            text: 'Ao comprar produtos do Astrolink você concorda com os nossos',
            link: 'Termos de Uso'
        },

        result: {
            success: {
                title: 'Compra Efetuada!',
                email: 'Você receberá uma confirmação no seu e-mail de cadastro',
                subscribe: {
                    title: 'Torne-se Premium',
                    discount:
                        'Assine o Astrolink Premium e garanta seu acesso a ferramentas e descontos exclusivos!',
                    subscribeButton: 'Escolha seu plano'
                },
                guide: {
                    title: 'O Mapa de Carreira já está disponível!',
                    message: 'Acesse quando quiser pelo menu <em>Explorar</em>',
                    readButton: 'Leia seu Mapa de Carreira'
                }
            },
            error: {
                title: 'Erro ao efetuar a compra 😕',
                message:
                    '<strong>{userName}</strong>, infelizmente ocorreu um erro, pedimos que você verifique as informações inseridas e se o problema persistir, nos contate através do nosso <a href="{supportUrl}">suporte</a>',
                backButton: 'Voltar'
            }
        }
    }
};
